import type { RefObject } from 'react';

import { Box, Flex } from '@bonusly/design-system';

import { RelativeTime } from '../../datetime';

interface BizyTimeDividerProps {
	/** The partition's moment — labeled via the shared relative-time formatter. */
	timestamp: Date;
	/**
	 * Distinguishes the fresh-start boundary (idle blank slate / archived
	 * segment, BIZY-683) from BIZY-638 burst breaks in tests and analytics.
	 */
	variant?: 'fresh-start' | 'burst-break';
	/** Scroll target for the blank-slate transition (fresh-start only). */
	dividerRef?: RefObject<HTMLDivElement>;
}

/**
 * Horizontal-rule time divider for every timeline partition: the idle
 * fresh-start boundary, archived-segment boundaries, and BIZY-638 burst
 * breaks. The generous vertical padding gives each partition a clear gap in
 * the conversation history.
 */
export function BizyTimeDivider({ timestamp, variant = 'burst-break', dividerRef }: BizyTimeDividerProps) {
	return (
		<Flex ref={dividerRef} align="center" gap={3} py={5} data-component={variant === 'fresh-start' ? 'bizy-fresh-start-divider' : 'bizy-timestamp-divider'}>
			<Box flex={1} borderTopWidth="1px" borderColor="border.soft" />
			<RelativeTime date={timestamp} format="long" fontSize="xs" fontWeight="medium" color="text.softest" whiteSpace="nowrap" />
			<Box flex={1} borderTopWidth="1px" borderColor="border.soft" />
		</Flex>
	);
}
